export default {
  currencySelectorState:
    localStorage.getItem("currency-selector-state") || true,

  policySelectorState: localStorage.getItem("policy-selector-state") || true,

  productsGainLossState: localStorage.getItem("products-gain-loss-state"),
};
